import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Output, EventEmitter } from "@angular/core";
import "leader-line";
import { fromEvent, Observable, Subscription } from "rxjs";
declare var LeaderLine: any;
import { ResizedEvent } from "angular-resize-event";
import { ResizeEvent } from "angular-resizable-element";
import { InstitutionControllerService } from "../../../../../services/institution-controller/institution-controller.service";
import { Institution } from "../../../../../models/institution";
import { Registration } from "../../../../../models/registration";
import { Store } from "../../../../../services/store.service";
import {
  ComponentActionControllerService,
} from "../../../../../services/form-controller/component-action-controller.service";
import {ActivatedRoute} from "@angular/router";
import {QueryBuilder} from "../../../../utils/query-builder/query-builder";
import { map } from 'rxjs/operators';

@Component({
    selector: "flow",
    templateUrl: "./flow.component.html",
    providers: [InstitutionControllerService, ComponentActionControllerService],
})
export class FlowComponent implements OnInit, OnDestroy {

    public root = document.documentElement;
    // Retrieve the current value of a CSS variable
    public currentColor = getComputedStyle(this.root).getPropertyValue('--color-gray-400');

    public _orderedMenuRoles: any[];
    public _rolesRows: any[];
    public showFlow: boolean = true;
    public useFullName: boolean = true;
    @Input() public baseUrl: string;
    @Input() public determinantMapById: { [key: string]: string };
    @Input() public institutions: Institution[] = [];
    @Input() public serviceRegistrations: Registration[] = [];
    @Input() public selectedRoleId: string = null;

    @Input() set orderedMenuRoles(value: any[]) {
        if (value && value.length) {
            this._orderedMenuRoles = [];
            this._rolesRows = [];
            this._orderedMenuRoles = value.filter((group) => group.length > 0);
            if (Array.isArray(this._orderedMenuRoles)) {
                if (this._orderedMenuRoles.length > 0) {
                    this._orderedMenuRoles.forEach((group) => {
                        if (group.length > 2) {
                            this.centerAlign = false;
                        }
                    });
                }
                this._rolesRows = this.getRows();
                this.changeDetectorRef.detectChanges();
                this.init();
            }
        }
    }
    @Output() public determinantSelectionChanged = new EventEmitter();
    @Output() public registrationSelectionChanged = new EventEmitter();
    @Output() public tutorialOpened = new EventEmitter();

    public determinantFilters: any[] = null;
    public registrationFilters: any[] = null;
    public hasDeterminantsFilter: boolean = false;
    public hasRegistrationsFilter: boolean = false;
    // logic vars
    private lines: any[] = [];
    private highlightedRoleIds: Set<string> = new Set();
    // leaderline vars
    public leaderLineColor: string = this.currentColor ? this.currentColor : "#000000";
    public leaderLineOverlapColor2: string = "#c8c8c9";
    public leaderLineOverlapColor: string = "#000000";
    public leaderLineOptions: any = {
        path: "grid",
        startPlug: "behind",
        endPlug: "arrow3",
        endPlugSize: 4,
        size: 1,
        color: this.leaderLineColor,
        endSocket: "auto",
        hide: true,
    };
    public resizeObservable$: Observable<Event>;
    public resizeSubscription$: Subscription;
    public centerAlign: boolean = true;
    public rowElementsCount = 6;
    public showDeterminantsFilters: boolean = false;
    public filtered: boolean = false;
    public showDetails: boolean = false;
    public showBots: boolean = true;
    public showInstitutions: boolean = true;
    public showRegistrations: boolean = false;
    public showDeterminants: boolean = true;
    public showFirstRoles: boolean = true;

    public style: object = {};
    public resizeEdges = { bottom: false, right: false, top: false, left: true };

    constructor(
      @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef,
      private institutionControllerService: InstitutionControllerService,
      private componentActionControllerService: ComponentActionControllerService,
      public store: Store,
      private route: ActivatedRoute,
    ) {
    }

    public ngOnInit() {
        console.log("--- gray-400", this.currentColor);
        if (localStorage.getItem("flowDetails")) {
            this.showDetails = localStorage.getItem("flowDetails") === "true" ? true : false;
        }
        if (localStorage.getItem("flowBots")) {
            this.showBots = localStorage.getItem("flowBots") === "true" ? true : false;
        }
        if (localStorage.getItem("flowInstitutions")) {
            this.showInstitutions = localStorage.getItem("flowInstitutions") === "true" ? true : false;
        }
        if (localStorage.getItem("flowRegistrations")) {
            this.showRegistrations = localStorage.getItem("flowRegistrations") === "true" ? true : false;
        }
        if (localStorage.getItem("flowDeterminants")) {
            this.showDeterminants = localStorage.getItem("flowDeterminants") === "true" ? true : false;
        }
        if (localStorage.getItem("flowFirstRoles")) {
            this.showFirstRoles = localStorage.getItem("flowFirstRoles") === "true" ? true : false;
        }
        if (!this.showBots || !this.showInstitutions || !this.showRegistrations || !this.showDeterminants || !this.showFirstRoles) {
            this.showDetails = false;
        }

        // Check if current URL matches any role URL and set showFlow accordingly
        // This prevents ExpressionChangedAfterItHasBeenCheckedError
        // @ts-ignore
        if (this.baseUrl && this.route._routerState?.snapshot?.url?.startsWith(this.baseUrl + '/')) {
            this.showFlow = false;
        }

        this.resizeObservable$ = fromEvent(window, "resize");
        this.resizeSubscription$ = this.resizeObservable$.subscribe((evt) => {
            this.updateLines();
        });
    }

    public displayedName(item) {
        return this.useFullName ? item.name : (item.shortName ? item.shortName : item.content);
    }
    public switchDisplayedName(event) {
        this.useFullName = event;
    }

    public ngOnDestroy() {
        this.removeLines();
        this.resizeSubscription$.unsubscribe();
    }

    public switchDetails(bool) {
        this.showDetails = bool;
        localStorage.setItem("flowDetails", this.showDetails ? "true" : "false");
        this.switchBots(bool);
        this.switchInstitutions(bool);
        this.switchRegistrations(bool);
        this.switchDeterminants(bool);
        this.switchFirstRoles(bool);
    }

    public switchBots(bool) {
        this.showBots = bool;
        localStorage.setItem("flowBots", this.showBots ? "true" : "false");
        this.checkIfAllDetails();
    }

    public switchInstitutions(bool) {
        this.showInstitutions = bool;
        localStorage.setItem("flowInstitutions", this.showInstitutions ? "true" : "false");
        this.checkIfAllDetails();
    }

    public switchRegistrations(bool) {
        this.showRegistrations = bool;
        localStorage.setItem("flowRegistrations", this.showRegistrations ? "true" : "false");
        this.checkIfAllDetails();
    }

    public switchDeterminants(bool) {
        this.showDeterminants = bool;
        localStorage.setItem("flowDeterminants", this.showDeterminants ? "true" : "false");
        this.checkIfAllDetails();
    }

    public switchFirstRoles(bool) {
        this.showFirstRoles = bool;
        localStorage.setItem("flowFirstRoles", this.showFirstRoles ? "true" : "false");
        this.checkIfAllDetails();
    }

    public checkIfAllDetails() {
        if (this.showInstitutions && this.showRegistrations && this.showFirstRoles && this.showBots && this.showDeterminants) {
            this.showDetails = true;
            localStorage.setItem("flowDetails", "true");
        } else {
            this.showDetails = false;
            localStorage.setItem("flowDetails", "false");
        }
    }

    // paint lines between roles
    public init(): void {
        // remove current lines
        this.addLines();
        this.initBotsCount();
    }

    public initBotsCount() {
        this._orderedMenuRoles.forEach((group, i) => {
            group.forEach((role) => {
                if (role.formSchema && role.formSchema.components.length) {
                    const Promises = [];
                    role.bots = this.lookForBots(role.formSchema.components, Promises);
                    Promise.all<any[]>(Promises).then((results: any[]) => {
                        const data = [];
                        const files = [];
                        results.filter((r) => r).forEach((r) => {
                            if (r.data) {
                                data.push(r.data);
                            }
                            if (r.files) {
                                files.push(r.files);
                            }
                        });
                        role.bots = { data, files };
                    });
                }
            });
        });
    }

    public lookForBots(components: any, promises) {
        let hasBots = null;
        if (components) {
            components.some((c) => {
                if (c.numberOfActions) {
                    hasBots = this.filterSystemActions(c.key, promises);
                    return hasBots;
                }
                if (c.components) {
                    hasBots = this.lookForBots(c.components, promises);
                    return hasBots;
                }
                if ((c.columns || c.rows) && c.type !== "textarea") {
                    const containers = c.columns || c.rows;
                    containers.some((container) => {
                        if (container.length) {
                            container.some((cont) => {
                                hasBots = this.lookForBots(cont.components, promises);
                                return hasBots;
                            });
                        } else {
                            hasBots = this.lookForBots(container.components, promises);
                            return hasBots;
                        }
                    });
                }
            });
        }
        return hasBots;
    }

    public filterSystemActions(key, promises) {
        let hasBotNotData = null;
        if (key && this.store.state.common.serviceId) {
            promises.push(
                this.componentActionControllerService.getComponentAction(this.store.state.common.serviceId, key).pipe(map(
                    (data) => {
                      // data is null caused by emptied response
                      if (data && data.actions && data.actions.length) {
                            const dataBots = data.actions.find((a) => {
                                if (a.bots && a.bots.length) {
                                    return a.bots.some((b) => {
                                        return b.botType === "data";
                                    });
                                } else {
                                    return null;
                                }
                            });
                            const fileBots = data.actions.find((a) => {
                                if (a.bots && a.bots.length) {
                                    return a.bots.some((b) => {
                                        return b.botType === "document";
                                    });
                                } else {
                                    return null;
                                }
                            });
                            const messageBots = data.actions.find((a) => {
                                if (a.bots && a.bots.length) {
                                    return a.bots.some((b) => {
                                        return b.botType === "message";
                                    });
                                } else {
                                    return null;
                                }
                            });
                            return { data: dataBots, files: fileBots, messages: messageBots };
                        }
                    },
                    (error) => {
                        return null;
                    },
                )).toPromise(),
            );
        } else {
            hasBotNotData = null;
        }
        return hasBotNotData;
    }

    public addLines(): void {
        this.removeLines();
        this._orderedMenuRoles.forEach((group, i) => {
            group.forEach((role) => {
                if (role.nextRoles && Array.isArray(role.nextRoles)) {

                    const isLastInRow = (i + 1) % this.rowElementsCount === 0;
                    const isRight = ((i + 1) / this.rowElementsCount) % 2 !== 0;

                    role.nextRoles.forEach((next) => {
                        const existingLine = this.lines.find((l) => l.startID === String(role.id) && l.endID === String(next.id));
                        if (this.existNext(next.id) && !existingLine) {
                            const startEl = document.getElementById(role.id);
                            const endEl = document.getElementById(next.id);
                            if (startEl && endEl) {
                                if (!isLastInRow) {
                                    if (this.offset(startEl).top < this.offset(endEl).top && this.offset(startEl).left + 340 < this.offset(endEl).left) {
                                        this.leaderLineOptions.endSocket = "top";
                                    } else {
                                        if (this.offset(startEl).top > this.offset(endEl).top && this.offset(startEl).left + 340 < this.offset(endEl).left) {
                                            this.leaderLineOptions.endSocket = "bottom";
                                        } else {
                                            this.leaderLineOptions.endSocket = "auto";
                                        }
                                    }
                                } else {
                                    if (isRight) {
                                        this.leaderLineOptions.endSocket = "right";
                                    } else {
                                        this.leaderLineOptions.endSocket = "left";
                                    }
                                }
                                const line = new LeaderLine(startEl, endEl, this.leaderLineOptions);
                                this.lines.push({
                                    startID: role.id,
                                    endID: next.id,
                                    startEl,
                                    endEl,
                                    line,
                                });
                                line.end = this.getEndElement(endEl);
                                line.hide();
                                this.addCustomLineClass(role.id, next.id);
                            }
                        }
                    });
                }
            });
        });
        setTimeout(() => {
        this.updateLines();
      }, 10);
        // window.dispatchEvent(new Event("resize"));
    }

    public addCustomLineClass(startID, endID): void {
        const domLines = document.querySelectorAll(".leader-line");
        if (domLines.length > 0 && startID && endID) {
            const domLine = document.querySelectorAll(".leader-line")[document.querySelectorAll(".leader-line").length - 1];
            domLine.classList.add("flow-line");
            domLine.id = startID + "-" + endID;
        }
    }

    public removeLines(): void {
        if (this.lines.length) {
            // remove visual lines
            this.lines.forEach((l) => {
                if (l.line) {
                    l.line.remove();
                    l.line = null;
                }
            });
            // clear lines collection
            this.lines = [];
        }
    }

    public updateLines(): void {
      this.lines.forEach((l) => {
        const start = document.getElementById(l.startID);
        const end = document.getElementById(l.endID);
        if (l.line) {
            if (!start || !end) {
              l.line.hide();
            }
            l.line.setOptions({ start, end });
            l.line.position();
            l.line.show();
          }
      });
    }

    public isForApplicant(item): boolean {
        return item.assignedTo === "applicant" || item.assignedTo === "applicantPayment";
    }

    public getEndElement(endEl): any {
        if (this.leaderLineOptions.endSocket === "bottom" && endEl) {
            return LeaderLine.pointAnchor(endEl, {x: "40%", y: "100%"});
        }
        return endEl;
    }

    public offset(el): any {
        if (!el) { return false; }
        const rect = el.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    public changeView(): void {
        this.changeDetectorRef.detectChanges();
        this.updateLines();
    }

    public getRows(): any[] {
        const rows = [];
        if (Array.isArray(this._orderedMenuRoles)) {
            rows.push([]);
            this._orderedMenuRoles.forEach((group) => {
                if (rows[rows.length - 1].length >= this.rowElementsCount) {
                    rows.push([]);
                }
                rows[rows.length - 1].push(group);
            });
        }
        return rows;
    }

    public getAncestorsMax(index): any {
        // check for 0
        if (index <= 0) {
            return {max: 0, on: "top"};
        }
        // exclude 0 elements as ancestor
        if (index - 1 > 0 && this._orderedMenuRoles[index - 1] && this._orderedMenuRoles[index]) {
            const prevMax = this.getAncestorsMax(index - 1);
            if (prevMax.on === "top" && prevMax.max <= this._orderedMenuRoles[index - 1].length) {
                return {
                    max: (this._orderedMenuRoles[index - 1].length > this._orderedMenuRoles[index].length ? this._orderedMenuRoles[index - 1].length - this._orderedMenuRoles[index].length : 0),
                    on: "bot",
                };
            } else {
                if (prevMax.on === "bot" && this._orderedMenuRoles[index - 1].length === this._orderedMenuRoles[index].length) {
                    return prevMax;
                }
            }
        }
        let maxm = 0;
        this._orderedMenuRoles.forEach((g, i) => {
            if (i < index) {
                maxm = maxm < g.length ? g.length : maxm;
            }
        });
        return {max: maxm, on: "top"};
    }

    public getArrayN(count): any[] {
        if (count > 0) {
            return Array(count);
        }
        return [];
    }

    public onResized(event: ResizedEvent) {
        this.rowElementsCount = Math.trunc((event.newWidth - 256) / 256);
        this._rolesRows = this.getRows();
        this.changeDetectorRef.detectChanges();
        this.init();
    }

    public roleDeterminants(roleDets): string {
        let detNamesList = "";
        if (roleDets !== null && roleDets !== "") {
            JSON.parse(roleDets).forEach((det, i) => {
                det.items.forEach((indet, j) => {
                  let detName = this.determinantMapById[indet.determinantId];
                  if (detNamesList !== "") {
                    detNamesList += "\n";
                  }
                  if (!detName) {
                    detName = QueryBuilder.findDeterminantName(indet, this.determinantMapById);
                  }
                  detNamesList += (j + 1) + ". " + detName;
                });
            });
        }
        return detNamesList;
    }

    public hasDeterminants(jDet): boolean {
        if (jDet === undefined || jDet === null || jDet === "") {
            return false;
        }
        try {
            const parsed = JSON.parse(jDet);
            return Array.isArray(parsed) && parsed[0]?.items?.length > 0;
        } catch {
            return false;
        }
    }

    public onResizeEnd(event: ResizeEvent) {
        this.style = {
            width: `${event.rectangle.width}px`,
        };
    }

    public closeSection() {
        this.style = {};
        this.toggleFlowDeterminantDrawer();

    }

    public onDeterminantSelectionChanged(event: any[]): void {
        this.removeLines();
        const cutBranchs = [];
        event.forEach((detItem) => {
            if (!detItem.checked) {
                cutBranchs.push(detItem);
            }
        });
        this.determinantFilters = event.filter((d) => d.checked);
        this.determinantSelectionChanged.emit(this.determinantFilters);
    }

    public onRegistrationSelectionChanged(event: any[]): void {
        this.removeLines();
        this.registrationFilters = event;
        this.registrationSelectionChanged.emit(event);
    }

    public get hasActiveFilters(): boolean {
        // Check if determinant filters are active (some unchecked)
        const hasDeterminantFilters = this.determinantFilters && this.determinantFilters.length > 0 &&
            this.determinantFilters.some(d => !d.checked);

        // Check if registration filters are active (some unchecked)
        const hasRegistrationFilters = this.registrationFilters && this.registrationFilters.length > 0 &&
            this.registrationFilters.some(r => !r.checked);

        return hasDeterminantFilters || hasRegistrationFilters;
    }

    public existNext(id): boolean {
        let exist = false;
        this._orderedMenuRoles.forEach((g) => {
            g.forEach((r) => {
                if (r.id === id) {
                    exist = true;
                }
            });
        });
        return exist;
    }

    public overItem(item, isTopLevel: boolean = true): void {
        // Collect highlighted role IDs only at top level
        if (isTopLevel) {
            this.highlightedRoleIds.clear();
            this.collectHighlightedRoles(item);
        }

        const selectedItem = document.getElementById(item.id);
        selectedItem.classList.add("highlighted");
        selectedItem.closest(".role-flow-item-wrapper")?.classList.add("highlighted");
        if (item.nextRoles && item.nextRoles.length > 0) {
            item.nextRoles.forEach((n) => {
                this.overItem(n, false);
            });
        }

        // Only apply DOM changes and filter lines at top level
        if (isTopLevel) {
            const container = document.getElementsByClassName("roles-flow-container");
            if (container[0]) {
                const allItems = container[0].querySelectorAll(".nav-link");
                for (const i of allItems as any) {
                    if (!i.classList.contains("highlighted")) {
                        i.classList.add("faded");
                        i.closest(".role-flow-item-wrapper")?.classList.add("faded");
                    }
                }
            }

            // Filter lines to only show those connecting highlighted roles
            this.filterLinesToHighlighted();
        }
    }

    public outItem(item): void {
        // Clear highlighted role IDs
        this.highlightedRoleIds.clear();

        const container = document.getElementsByClassName("roles-flow-container");
        if (container[0]) {
            const allItems = container[0].querySelectorAll(".nav-link");
            for (const i of allItems as any) {
                i.classList.remove("faded");
                i.classList.remove("highlighted");
                i.closest(".role-flow-item-wrapper")?.classList.remove("faded");
                i.closest(".role-flow-item-wrapper")?.classList.remove("highlighted");
            }
        }
        if (item.nextRoles && item.nextRoles.length > 0) {
            item.nextRoles.forEach((n) => {
                this.outItem(n);
            });
        }

        // Show all lines again
        this.showAllLines();
    }

    private collectHighlightedRoles(item): void {
        // Add current role to highlighted set
        this.highlightedRoleIds.add(item.id);

        // Recursively add next roles
        if (item.nextRoles && item.nextRoles.length > 0) {
            item.nextRoles.forEach((n) => {
                this.collectHighlightedRoles(n);
            });
        }
    }

    private filterLinesToHighlighted(): void {
        // Hide all lines that don't connect highlighted roles
        this.lines.forEach((l) => {
            if (l.line) {
                const startHighlighted = this.highlightedRoleIds.has(l.startID);
                const endHighlighted = this.highlightedRoleIds.has(l.endID);

                // Only show lines where both start and end are highlighted
                if (startHighlighted && endHighlighted) {
                    l.line.show();
                } else {
                    l.line.hide();
                }
            }
        });
    }

    private showAllLines(): void {
        // Show all lines
        this.lines.forEach((l) => {
            if (l.line) {
                l.line.show();
            }
        });
    }

    public markLines(startID, endID): void {
        if (this.lines.length > 0) {
            this.lines.forEach((l) => {
                if (l.line !== null && l.startID === startID && l.endID === endID) {
                    l.line.setOptions({
                        color: this.leaderLineColor,
                    });
                    const domLine = document.getElementById(startID + "-" + endID);
                    if (domLine) {
                        domLine.classList.add("overlap");
                    }
                }
            });
        }
    }

    public unMarkLines(startID, endID): void {
        if (this.lines.length > 0) {
            this.lines.forEach((l) => {
                if (l.line !== null && l.startID === startID && l.endID === endID) {
                    l.line.setOptions({
                        color: this.leaderLineColor,
                    });
                    const domLine = document.getElementById(startID + "-" + endID);
                    if (domLine) {
                        domLine.classList.remove("overlap");
                    }
                }
            });
        }
    }

    public toggleFlowDeterminantDrawer(): void {
        this.showDeterminantsFilters = !this.showDeterminantsFilters;
        if (!this.showDeterminantsFilters) {
            this.showLines();
        } else {
            this.hideLines();
        }
    }

    public hideLines(): void {
        document.querySelectorAll(".flow-line").forEach((l) => {
            l.classList.add("overlap");
        });
    }

    public showLines(): void {
        document.querySelectorAll(".flow-line").forEach((l) => {
            l.classList.remove("overlap");
        });
    }

    public getRoleInstitution(role): string {
        if (this.institutions?.length && role.roleInstitutions?.length) {
            const institution = this.institutions.filter((i) => i.id.toString() === role.roleInstitutions[0].institutionId);
            return institution.length ? (institution[0].shortName ? institution[0].shortName : institution[0].name) : "";
        }
        return "";
    }

    public getRoleInstitutionName(role): any {
        if (this.institutions?.length && role.roleInstitutions?.length) {
            const insts = {
                first: "",
                lines: "",
            };
            role.roleInstitutions.forEach((institution, index) => {
                const selectedInst = this.institutions.find((i) => i.id.toString() === institution.institutionId);
                if (selectedInst) {
                    if (index > 1) {
                        insts.lines += `<div>${selectedInst.name}</div>`;
                    } else {
                      insts.first += `<div>${selectedInst.name}</div>`;
                    }
                }
            });
            return insts;
        }
        return "";
    }

    public getBotRoleType(role) {
        let countData = 0;
        let countDocument = 0;
        let countInternal = 0;
        let countMessage = 0;
        if (role?.botRoleBots?.actions?.length) {
            role?.botRoleBots?.actions.forEach((a) => {
                switch (a.bots[0]?.botType) {
                    case "internal":
                        countInternal++;
                        break;
                    case "document":
                        countDocument++;
                        break;
                    case "data":
                        countData++;
                        break;
                    case "message":
                        countMessage++;
                        break;
                }
            });
            if (countData === 0 && countDocument === 0 && countInternal === 0 && countMessage === 0) {
                return "empty";
            } else if (countData > 0 && countDocument === 0 && countInternal === 0 && countMessage === 0) {
                return "data";
            } else if (countData === 0 && countDocument > 0 && countInternal === 0 && countMessage === 0) {
                return "document";
            } else if (countData === 0 && countDocument === 0 && countMessage === 0 && countInternal > 0) {
                return "internal";
            } else if (countData === 0 && countDocument === 0 && countMessage >= 0 && countInternal === 0) {
                return "message";
            } else {
                return "mixed";
            }
        } else {
            return "empty";
        }
    }

  public urlStartWith(url: string) {
    // Only check URL, don't modify state (to prevent ExpressionChangedAfterItHasBeenCheckedError)
    // @ts-ignore
    return this.route._routerState.snapshot.url.startsWith(url);
  }

  public getRoleBots(role) {
    return role?.botRoleBots?.actions?.length;
  }

    public getBotIcon(type) {
        switch (type) {
            case "document":
                return "fa-file";
            case "internal":
                return "fa-network-wired";
            case "message":
                return "fa-envelope";
            default:
            case "data":
            return "fa-database";
        }
    }

    public openTutorial() {
        this.tutorialOpened.emit();
    }

}
